import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/ServicesPage.module.css";
import videoBackground from "../styles/background.mp4";
import ClientNotification from "../shared/ClientNotification";

const ServicesPage = () => {
  const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(false);
  const [redirectPath, setRedirectPath] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleShowNotification = (path) => {
    setRedirectPath(path);
    setShowNotification(true);
  };

  const handleNotificationConfirm = () => {
    setShowNotification(false);
    navigate(redirectPath);
  };

  return (
    <div className={styles.sevicesPageContainer}>
      <video className={styles.sevicesPageVideoBackground} autoPlay loop muted>
        <source src={videoBackground} type="video/mp4" />
      </video>

      {showNotification && (
        <ClientNotification onConfirm={handleNotificationConfirm} />
      )}

      {/* Header */}
      <header className={styles.servicesPageHeaderMenu}>
        <div
          onClick={() => navigate("/")}
          className={styles.servicesPageLogo}
        >
          Full Trucking Service
        </div>
        <div
          className={styles.hamburgerServices}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          ☰
        </div>
        <nav
          className={`${styles.navMenuServices} ${
            isMenuOpen ? styles.activeServices : ""
          }`}
        >
          <ul>
            <li onClick={() => navigate("/about")}>About Us</li>
            <li onClick={() => navigate("/services")}>Services</li>
            <li onClick={() => navigate("/contact")}>Contact</li>
            <li onClick={() => navigate("/pricing")}>Register</li>
          </ul>
        </nav>
      </header>

      {/* Main Content */}
      <div className={styles.sevicesPageMainContent}>
        <div className={styles.sevicesPagetextSection}>
          <h1>Our Services</h1>
          <p>
            At Full Trucking Service (FTS), we provide a complete suite of tools
            designed for trucking companies, owner-operators, self-employed
            drivers, and enterprise-level businesses. Whether you manage a
            single truck or a large fleet, FTS offers flexible subscription
            packages that give you the right balance between features and cost.
          </p>

          <h1>Subscription Plans</h1>
          <p>We understand that not every business needs the same level of support. That’s why we offer tailored plans to fit your exact needs.</p>

          <h2>Simple Statement</h2>
          <p>
            <strong>$3.99/month</strong>, or just <strong>$1.99/month annually</strong> with 2 months free. Perfect for owner-operators or self-employed users who want to create payrolls manually with minimal overhead.
          </p>

          <h2>Basic</h2>
          <p>
            <strong>$9.99/month</strong>, or <strong>$3.99/month annually</strong> with 2 months free. Ideal for small businesses looking for simple but reliable management.
          </p>

          <h2>Standard</h2>
          <p>
            <strong>$19.99/month</strong>, or <strong>$9.99/month annually</strong> with 2 months free. Designed for companies that want to streamline operations and reduce paperwork.
          </p>

          <h2>Premium</h2>
          <p>
            <strong>$39.99/month</strong>, or <strong>$19.99/month annually</strong> with 2 months free. A powerful package for growing fleets that need automation and advanced reporting.
          </p>

          <h2>Ultimate</h2>
          <p>
            <strong>$69.99/month</strong>, or <strong>$49.99/month annually</strong> with 2 months free. Includes advanced dashboards, AI features, and full-scale fleet management.
          </p>

          <h2>Enterprise</h2>
          <p>
            <strong>$159.99/month</strong>, or <strong>$129.99/month annually</strong> with 2 months free. Tailored for large corporations that require high-level customization, scalability, and dedicated support.
          </p>

          <h1>Platform Features</h1>
          <ul>
            <li><strong>Load Management:</strong> Add, track, and assign loads efficiently with AI-powered automation.</li>
            <li><strong>Payroll Processing:</strong> Automate driver payments and save salary history for future reference.</li>
            <li><strong>Fuel & IFTA:</strong> Generate fuel reports, enter IFTA manually, and track fuel consumption in real time.</li>
            <li><strong>Fleet & Driver Monitoring:</strong> Real-time GPS tracking for drivers and trucks, with live dispatch control.</li>
            <li><strong>Expense & Profit Analysis:</strong> Get instant insights into revenues, expenses, and profit margins.</li>
            <li><strong>Invoicing & Billing:</strong> Generate invoices, send them directly by email, and forward unpaid invoices to factoring.</li>
            <li><strong>Document Management:</strong> Drivers can scan and upload documents from the mobile app straight to dispatch chat.</li>
            <li><strong>Custom Dashboards:</strong> Add charts, monitor KPIs, set goals, and receive AI-driven strategy suggestions.</li>
            <li><strong>Collaboration:</strong> Create dispatcher and accounting accounts with custom permissions for team management.</li>
            <li><strong>Balance Sheet:</strong> See real-time company balance and upcoming payments or receivables.</li>
          </ul>

          <h1>Why Choose FTS?</h1>
          <p>
            With years of experience in the trucking industry, our platform was designed by professionals who understand the everyday challenges of dispatchers, drivers, and fleet managers. FTS is not just software, it is a complete ecosystem that gives you control over every aspect of your business.
          </p>

          <p>
            From real-time driver communication and AI-powered load entry to payroll, invoicing, and compliance, FTS simplifies complex tasks and allows companies to operate smarter, faster, and more profitably.
          </p>

          <button
            className={styles.sevicesPagepricingButton}
            onClick={() => handleShowNotification("/pricing")}
          >
            View Pricing Plans
          </button>
        </div>
      </div>

      {/* Footer */}
      <footer className={styles.sevicesPageFooter}>
        <a
          href="https://2-bfs.com/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.sevicesPagefooterLink}
        >
          Terms of Service
        </a>
        <a
          href="https://2-bfs.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.sevicesPagefooterLink}
        >
          Privacy Policy
        </a>
        <a
          href="https://2-bfs.com/panda-help"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.sevicesPagefooterLink}
        >
          Help
        </a>
      </footer>
    </div>
  );
};

export default ServicesPage;
